module.exports = __webpack_public_path__ + "media/preview/conference@1x-85aa9305.png";